import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { JSONMap as e } from "../../core/jsonMap.js";
import { JSONSupport as i } from "../../core/JSONSupport.js";
import { clone as s } from "../../core/lang.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as a } from "../../core/accessorSupport/decorators/writer.js";

var _c;

var n = new e({
  count: "count",
  sum: "sum",
  min: "min",
  max: "max",
  avg: "avg",
  stddev: "stddev",
  var: "var",
  exceedslimit: "exceedslimit",
  percentile_cont: "percentile-continuous",
  percentile_disc: "percentile-discrete"
});

var p = _c = /*#__PURE__*/function (_i) {
  _inherits(c, _i);

  var _super = _createSuper(c);

  function c(t) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, t), _this.maxPointCount = void 0, _this.maxRecordCount = void 0, _this.maxVertexCount = void 0, _this.onStatisticField = null, _this.outStatisticFieldName = null, _this.statisticType = null, _this.statisticParameters = null;
    return _this;
  }

  _createClass(c, [{
    key: "writeStatisticParameters",
    value: function writeStatisticParameters(t, e) {
      "percentile-continuous" !== this.statisticType && "percentile-discrete" !== this.statisticType || (e.statisticParameters = s(t));
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _c({
        maxPointCount: this.maxPointCount,
        maxRecordCount: this.maxRecordCount,
        maxVertexCount: this.maxVertexCount,
        onStatisticField: this.onStatisticField,
        outStatisticFieldName: this.outStatisticFieldName,
        statisticType: this.statisticType,
        statisticParameters: s(this.statisticParameters)
      });
    }
  }]);

  return c;
}(i);

t([r({
  type: Number,
  json: {
    write: !0
  }
})], p.prototype, "maxPointCount", void 0), t([r({
  type: Number,
  json: {
    write: !0
  }
})], p.prototype, "maxRecordCount", void 0), t([r({
  type: Number,
  json: {
    write: !0
  }
})], p.prototype, "maxVertexCount", void 0), t([r({
  type: String,
  json: {
    write: !0
  }
})], p.prototype, "onStatisticField", void 0), t([r({
  type: String,
  json: {
    write: !0
  }
})], p.prototype, "outStatisticFieldName", void 0), t([r({
  type: String,
  json: {
    read: {
      source: "statisticType",
      reader: n.read
    },
    write: {
      target: "statisticType",
      writer: n.write
    }
  }
})], p.prototype, "statisticType", void 0), t([r({
  type: Object
})], p.prototype, "statisticParameters", void 0), t([a("statisticParameters")], p.prototype, "writeStatisticParameters", null), p = _c = t([o("esri.rest.support.StatisticDefinition")], p);
var m = p;
export { m as default };